import { ModuleWithProviders, NgModule } from '@angular/core';

import { Icd10CodeSearchConfiguration, IIcd10CodeSearchConfiguration } from './icd10-code-search-configuration';

@NgModule()
export class Icd10CodeSearchModule {
  static forRoot(params: IIcd10CodeSearchConfiguration): ModuleWithProviders<Icd10CodeSearchModule> {
    return {
      ngModule: Icd10CodeSearchModule,
      providers: [{ provide: Icd10CodeSearchConfiguration, useValue: params }],
    };
  }
}
